import React, { useState } from "react";
import swal from "sweetalert";
import LoadingOverlay from "react-loading-overlay";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Link, useParams } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "./DetailPatient.css";
import { Alert, Button, Modal, Space, Typography, Input, message } from "antd";
import { WarningFilled } from "@ant-design/icons";
import Spacer from "../../../Spacer";
import ICRemoveDuplicate from "@Assets/icons/ic-remove-duplicate.svg";
import { TableDuplicateData } from "../../DuplicateData/components/TableDuplicateData/TableDuplicateData";
import { useGetParentDetail } from "./hooks/useGetParentDetail";
import { useGetJob } from "./hooks/useGetJob";
import { useGetDistrict } from "./hooks/useGetDistrict";
import { useGetCity } from "./hooks/useGetCity";
import { useGetProvince } from "./hooks/useGetProvince";
import { useDeleteChildMutation } from "./hooks/useDeleteChildMutation";
import { useDeleteDuplicateMutation } from "./hooks/useDeleteDuplicateMutation";
import { useUpdateWhatsappMutation } from "./hooks/useUpdateWhatsappMutation";

const { SearchBar } = Search;
const { Title } = Typography;

function dateFormatter(cell, row, rowIndex, formatExtraData) {
  if (cell !== null) {
    let date = new Date(cell);
    let dd = date.getDate();
    let mm = date.getMonth() + 1; //January is 0!

    let yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    let set_date = dd + "-" + mm + "-" + yyyy;
    return set_date;
  } else {
    return "-";
  }
}

function genderFormatter(cell, row, rowIndex, formatExtraData) {
  if (row.gender === "female") {
    return <p>Perempuan</p>;
  } else {
    return <p>Laki-laki</p>;
  }
}

const DetailPatient = () => {
  const { value: parentId } = useParams();
  const [isShowModalDeleteDataDuplicate, setIsShowModalDeleteDataDuplicate] = useState(false);
  const [isShowModalWhatsapp, setIsShowModalWhatsapp] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [selectedDataDetail, setSelectedDataDetail] = useState([]);

  const { data: parentDetail, isLoading: isLoadingParent } = useGetParentDetail(parentId);
  const { data: fatherJob } = useGetJob(parentDetail?.father_job_id);
  const { data: motherJob } = useGetJob(parentDetail?.mother_job_id);
  const { data: district } = useGetDistrict(parentDetail?.district_id);
  const { data: city } = useGetCity(parentDetail?.city_id);
  const { data: province } = useGetProvince(parentDetail?.province_id);

  const deleteChildMutation = useDeleteChildMutation(parentId);

  const deleteDuplicateMutation = useDeleteDuplicateMutation(parentId, () => {
    setSelectedDataDetail([]);
    setIsShowModalDeleteDataDuplicate(false);
  });

  const userId = parentDetail?.user?.id;

  const updateWhatsappMutation = useUpdateWhatsappMutation(userId, parentId, () => {
    setIsShowModalWhatsapp(false);
    setWhatsappNumber("");
  });

  const detailPatientFormatter = (cell, row) => {
    return (
      <div className="detail-buttons">
        <button
          onClick={() => {
            swal({
              title: "Yakin Ingin Menghapus?",
              icon: "warning",
              buttons: ["Batal", "Hapus"],
              dangerMode: true,
            }).then((move) => {
              if (move) {
                deleteChildMutation.mutate(row.id);
              }
            });
          }}
          className="btn btn-danger patient-delete"
        >
          Hapus
        </button>
        <Link to={`/change-patient-data/${row.id}`}>
          <button className="btn btn-primary patient-change">Ubah</button>
        </Link>
        <Link to={`/checkup-history/${row.id}`}>
          <button className="btn btn-info patient-checkup">
            Riwayat Pemeriksaan
          </button>
        </Link>
        <Link to={`/upcoming-schedule/${row.id}`}>
          <button className="btn btn-info patient-checkup">
            Jadwal Mendatang
          </button>
        </Link>
      </div>
    );
  };

  const columns = [
    {
      dataField: "fullname",
      text: "Nama",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      dataField: "gender",
      text: "Jenis Kelamin",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      formatter: genderFormatter,
    },
    {
      dataField: "birthdate",
      text: "Tanggal Lahir",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      formatter: dateFormatter,
    },
    {
      dataField: "birthplace",
      text: "Tempat Lahir",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      formatter: (cell) => (cell !== null ? cell : "-"),
    },
    {
      dataField: "Aksi",
      text: "Aksi",
      headerStyle: { textAlign: "center" },
      style: { margin: "auto" },
      formatter: detailPatientFormatter,
    },
  ];

  const products = parentDetail?.children || [];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total showing-button">
      Menampilkan {from} / {to} dari {size} Hasil
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: products.length || 1 },
    ],
  };

  const contentTable = ({ paginationTableProps }) => (
    <div className="text-left">
      <p className="family-members float-left mt-5">
        Anggota Keluarga {products.length > 0 ? "" : ""}
      </p>
      <ToolkitProvider
        keyField="id"
        columns={columns}
        data={products}
        search={{ searchFormatted: true }}
      >
        {(toolkitprops) => (
          <div>
            <SearchBar {...toolkitprops.searchProps} className="search-content" />
            <BootstrapTable
              bordered={false}
              {...toolkitprops.baseProps}
              {...paginationTableProps}
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );

  const dataOriginal = parentDetail
    ? [
      {
        father_name: parentDetail.father_name,
        mother_name: parentDetail.mother_name,
        children_count: parentDetail.children_count,
        last_visit_date: parentDetail.last_visit_date,
        is_registered_on_app: parentDetail.is_registered_on_app,
        duplicate_data_count: parentDetail.duplicate_data_count,
        no: 1,
        key: 1,
        id: parentDetail.id,
      },
    ]
    : [];

  const email = parentDetail?.user?.email;
  const duplicate_data_count = parentDetail?.duplicate_data_count || 0;
  const duplicate_data = parentDetail?.duplicate_data || [];

  return (
    <>
      <LoadingOverlay active={isLoadingParent} spinner text="Memuat data...">
        <div className="content-section">
          <div className="title-section">
            <h1 className="patient-page-title">Detail Keluarga</h1>
            <h2 className="patient-page-subtitle">
              <span style={{ color: "#039BEB" }}>Manajemen Pasien</span>
              <span style={{ color: "#039BEB" }}> / Daftar Kepala Keluarga</span>
              <span style={{ color: "#00000029" }}> / Detail Kepala Keluarga</span>
            </h2>
            <div className="add-button mr-3">
              <Link to={`/add-member/${parentId}`}>
                <button className="btn btn-primary btn-add-table mb-3">
                  Tambah Anggota Keluarga
                </button>
              </Link>
            </div>
          </div>
          <div className="card shadow mb-4">
            <div className="card-body">
              {duplicate_data_count > 0 && (
                <Alert
                  message="Terdapat kesamaan data dengan data keluarga lainnya"
                  type="warning"
                  style={{
                    borderRadius: 10,
                    textAlign: "left",
                  }}
                  icon={<WarningFilled />}
                  showIcon
                  action={
                    <Button
                      size="small"
                      type="text"
                      onClick={() => setIsShowModalDeleteDataDuplicate(true)}
                      style={{
                        color: "#FFB400",
                      }}
                    >
                      Bandingkan Data
                    </Button>
                  }
                />
              )}
              <Spacer height={10} />
              <table cellPadding="10" className="parent-data text-left mb-3">
                <tbody>
                  <tr>
                    <td>Email</td>
                    <td>
                      :{" "}
                      {email ? (
                        email
                      ) : (
                        <span className="text-danger">Belum Terdaftar</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>No. Whatsapp</td>
                    <td>
                      :{" "}
                      {parentDetail?.user?.auth_providers?.[0]?.phone_number ? (
                        parentDetail.user.auth_providers[0].phone_number
                      ) : email ? (
                        <Button
                          size="small"
                          type="primary"
                          onClick={() => setIsShowModalWhatsapp(true)}
                        >
                          Tambah Whatsapp
                        </Button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Nama Ayah</td>
                    <td>: {parentDetail?.father_name || "-"}</td>
                  </tr>
                  <tr>
                    <td>Nama Ibu</td>
                    <td>: {parentDetail?.mother_name || "-"}</td>
                  </tr>
                  <tr>
                    <td>Pekerjaan Ayah </td>
                    <td>: {fatherJob || "-"}</td>
                  </tr>
                  <tr>
                    <td>Pekerjaan Ibu </td>
                    <td>: {motherJob || "-"}</td>
                  </tr>
                  <tr>
                    <td>No. Telp Ayah</td>
                    <td>: {parentDetail?.phone_number || "-"}</td>
                  </tr>
                  <tr>
                    <td>No. Telp Ibu</td>
                    <td>: {parentDetail?.mother_phone_number || "-"}</td>
                  </tr>
                  <tr>
                    <td>Alamat</td>
                    <td>
                      : {parentDetail?.address || ""}{" "}
                      {district && district !== "-" ? `, Kecamatan ${district}` : ""}{" "}
                      {city && city !== "-" ? `, ${city}` : ""}{" "}
                      {province && province !== "-" ? `, Provinsi ${province}` : ""}
                    </td>
                  </tr>
                </tbody>
              </table>
              <PaginationProvider pagination={paginationFactory(options)}>
                {contentTable}
              </PaginationProvider>
              <div className="patient-buttons">
                <Link to="/patients">
                  <button className="btn btn-secondary mt-5 text-light">
                    Kembali
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>

      <Modal
        visible={isShowModalDeleteDataDuplicate}
        onOk={() => { }}
        zIndex={9999999}
        className="modal-duplicate-data-certificate"
        onCancel={() => {
          setIsShowModalDeleteDataDuplicate(false);
          setSelectedDataDetail([]);
        }}
        footer={null}
      >
        <div className="modal-duplicate-data-wrapper">
          <img src={ICRemoveDuplicate} alt="ic-remove-duplicate.svg" />
          <Spacer height={30} />
          <Title level={4}>Request Diterima</Title>
          <p className="modal-duplicate-data-description">
            Anda akan menghapus data duplikat user Klinik Utama Pediatrica
            dengan detail sebagai berikut:
          </p>

          <Spacer height={16} />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <Title level={5}>Data Original</Title>
          </div>
          <div style={{ maxWidth: "100%" }}>
            <TableDuplicateData
              dataSource={dataOriginal}
              isDetail={isShowModalDeleteDataDuplicate}
              rowSelection={{
                type: "checkbox",
                hideSelectAll: true,
                selectedRowKeys: selectedDataDetail?.map((item) => item?.id),
                onSelect: (record, selected) => {
                  if (selected) {
                    setSelectedDataDetail([...selectedDataDetail, record]);
                  } else {
                    const tempData = selectedDataDetail?.filter(
                      (item) => item?.id !== record?.id
                    );
                    setSelectedDataDetail(tempData);
                  }
                },
              }}
            />
          </div>

          <Spacer height={16} />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <Title level={5}>Data Duplicate</Title>
          </div>
          <div style={{ maxWidth: "100%" }}>
            <TableDuplicateData
              dataSource={duplicate_data}
              isDetail={isShowModalDeleteDataDuplicate}
              rowSelection={{
                type: "checkbox",
                hideSelectAll: true,
                selectedRowKeys: selectedDataDetail?.map((item) => item?.id),
                onSelect: (record, selected) => {
                  if (selected) {
                    setSelectedDataDetail([...selectedDataDetail, record]);
                  } else {
                    const tempData = selectedDataDetail?.filter(
                      (item) => item?.id !== record?.id
                    );
                    setSelectedDataDetail(tempData);
                  }
                },
              }}
            />
          </div>

          <Spacer height={34} />
          <div>
            <Space size="small">
              <Button
                onClick={() => {
                  setIsShowModalDeleteDataDuplicate(false);
                  setSelectedDataDetail([]);
                }}
              >
                Batalkan
              </Button>
              <Button
                type="primary"
                danger
                style={{
                  ...(!!selectedDataDetail?.length && {
                    background: "#CB444A",
                  }),
                  display: "flex",
                  alignItems: "center",
                }}
                loading={deleteDuplicateMutation.isLoading}
                onClick={() => deleteDuplicateMutation.mutate(selectedDataDetail)}
              >
                Hapus Duplikasi
              </Button>
            </Space>
          </div>
        </div>
      </Modal>

      <Modal
        visible={isShowModalWhatsapp}
        onCancel={() => {
          setIsShowModalWhatsapp(false);
          setWhatsappNumber("");
        }}
        title="Tambah Nomor Whatsapp"
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsShowModalWhatsapp(false);
              setWhatsappNumber("");
            }}
          >
            Batal
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={updateWhatsappMutation.isLoading}
            onClick={() => {
              const phoneRegex = /^[0-9]{10,14}$/;
              if (!phoneRegex.test(whatsappNumber)) {
                message.error("Masukkan nomor telepon yang valid (10-14 digit angka)");
                return;
              }
              updateWhatsappMutation.mutate(whatsappNumber);
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          Masukkan nomor whatsapp yang valid:
        </div>
        <Input
          placeholder="Contoh: 08123456789"
          value={whatsappNumber}
          onChange={(e) => setWhatsappNumber(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default DetailPatient;

